import React from "react"
import VersusPage from "../../templates/hotels/VersusPage"

const Page = () => <VersusPage duelKey="bauchartVsLaReserve" locale="fr" />

export default Page
